import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'privacySettings.components.pageTitle',
        defaultMessage: 'Settings'
    },
    studentNameDisplay: {
        id: 'privacySettings.components.studentNameDisplay',
        defaultMessage: 'Student name display'
    },
    save: {
        id: 'privacySettings.components.save',
        defaultMessage: 'Save'
    },
    cancel: {
        id: 'privacySettings.components.cancel',
        defaultMessage: 'Cancel'
    },
    option1: {
        id: 'privacySettings.components.option1',
        defaultMessage: 'First name with first initial (e.g. John S.)'
    },
    option2: {
        id: 'privacySettings.components.option2',
        defaultMessage: 'Initials only (e.g. JS)'
    },
    option3: {
        id: 'privacySettings.components.option3',
        defaultMessage: 'Initials with surname first (e.g. SJ)'
    },
    studentNameDisplayText: {
        id: 'privacySettings.components.studentNameDisplayText',
        defaultMessage: 'Affects the display of student names within <strong>Mathletics Hall of Fame</strong> and <strong>Live Mathletics</strong>'
    },
    schoolLanguageSettings: {
        id: 'privacySettings.components.schoolLanguageSettings',
        defaultMessage: 'School Language Settings'
    },
    country: {
        id: 'privacySettings.components.country',
        defaultMessage: 'Country'
    },
    countryDescripition: {
        id: 'privacySettings.components.countryDescripition',
        defaultMessage: 'This will determine which curated content will be presented to students and teachers'
    },
    languageVariant: {
        id: 'privacySettings.components.languageVariant',
        defaultMessage: 'Language Variant'
    },
    languageVariantDescripition: {
        id: 'privacySettings.components.languageVariantDescripition',
        defaultMessage: 'Sets the default language and local culture variants for your school'
    },
    currentAcademicYear: {
        id: 'privacySettings.components.currentAcademicYear',
        defaultMessage: 'Current Academic Year'
    },
    academicYearName: {
        id: 'privacySettings.components.academicYearName',
        defineMessage: 'Academic Year name'
    },
    region: {
        id: 'privacySettings.components.region',
        defineMessage: 'Region or School based setting'
    },
    dateStart: {
        id: 'privacySettings.components.dateStart',
        defineMessage: 'Start'
    },
    dateEnd: {
        id: 'privacySettings.components.dateEnd',
        defineMessage: 'End'
    },
    contact: {
        id: 'privacySettings.components.contact',
        defineMessage: 'Contact us to change your current Academic Year'
    },
    currentAcademicYearDescriptionOne: {
        id: 'privacySettings.components.currentAcademicYearDescriptionOne',
        defaultMessage: 'The current academic year for a school has historically been based on that school’s region. We now have the capability to enter a custom academic year for any school.'
    },
    currentAcademicYearDescriptionTwo: {
        id: 'privacySettings.components.currentAcademicYearDescriptionTwo',
        defaultMessage: 'Your school’s academic year details are displayed in this panel including the name, dates and whether it is a custom school year or the default region year.'
    },
    currentAcademicYearDescriptionThree: {
        id: 'privacySettings.components.currentAcademicYearDescriptionThree',
        defaultMessage: 'If you would like to move from the region-based year to a custom school year, or you have a custom school year but would like to update the end date, please contact us via the link below.'
    },
    regionLevel: {
        id: 'privacySettings.components.regionLevel',
        defaultMessage: 'Region'
    },
    schoolLevel: {
        id: 'privacySettings.components.schoolLevel',
        defaultMessage: 'School'
    },
    nullAcademicYear: {
        id: 'privacySettings.components.nullAcademicYear',
        defineMessage: 'Unable to retrieve current academic year details.'
    }
});



// WEBPACK FOOTER //
// ./app/components/privacy-settings/messages.js